import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "sonner";
import { PlayCircle } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { hasPerm, isTeam } from "../lib/team";

const enterDemo = async () => {
  try { await http.post("/superadmin/demo/enter"); window.location.href = "/"; } catch (e) { toast.error(formatApiError(e)); }
};

const UnpaidLinks = () => {
  const [list, setList] = useState([]);
  useEffect(() => { http.get("/subscription/unpaid").then((r) => setList(r.data)).catch(() => {}); }, []);
  return list.map((x) => (
    <a key={x.number} href={x.pay_url} className="inline-flex items-center mr-3 px-3 py-0.5 rounded-full bg-[#0B2A7A] text-white font-semibold text-xs" data-testid={`unpaid-pay-${x.number}`}>Payer la facture {x.number} en ligne</a>
  ));
};

export const ShellBanners = ({ user }) => {
  const c = user?.company;
  const lim = user?.agent_limit;
  const n = user?.agents_active ?? 0;
  const near = lim && n >= Math.max(lim - 2, Math.ceil(lim * 0.9));
  const upgrade = `/service-client?objet=${encodeURIComponent("Passage au palier supérieur de mon abonnement XALTIX")}`;
  return (
    <>
      {isTeam(user) && hasPerm(user, "demo") && (
        <div data-testid="demo-launch-bar" className="bg-slate-900 text-white text-sm px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1">
          <span className="text-slate-300">Démonstration client :</span>
          <button onClick={enterDemo} className="inline-flex items-center gap-1.5 font-semibold text-[#E8C46A] hover:underline" data-testid="demo-enter-btn"><PlayCircle className="h-4 w-4" />Ouvrir l'entreprise XALTIX Démo</button>
          <span className="text-xs text-slate-400 hidden md:inline">(reconnectez-vous ensuite à votre compte)</span>
        </div>
      )}
      {c?.is_demo && (
        <div data-testid="demo-mode-banner" className="bg-[#0B2A7A] text-white text-sm px-4 py-2 text-center">Mode démonstration — toutes les données sont fictives.</div>
      )}
      {c?.status === "suspended" && (
        <div data-testid="suspended-banner" className="bg-amber-100 border-b border-amber-300 text-amber-900 text-sm px-4 py-2 text-center">
          {c.status_reason_code === "unpaid" ? "Compte en consultation seule : une facture XALTIX est impayée. L'accès complet revient dès réception du paiement. " : "Compte suspendu : consultation uniquement, sans modification ni exportation. "}
          {c.status_reason_code === "unpaid" && <UnpaidLinks />}<NavLink to="/service-client" className="font-semibold underline">Contacter le service client</NavLink>
        </div>
      )}
      {near && (
        <div data-testid="agent-limit-banner" className={`text-sm px-4 py-2 text-center border-b ${n >= lim ? "bg-rose-50 border-rose-200 text-rose-800" : "bg-sky-50 border-sky-200 text-sky-900"}`}>
          {n >= lim ? `Limite atteinte : ${n}/${lim} agents actifs. Vous ne pouvez plus ajouter d'agent.` : `Vous approchez de la limite de votre formule : ${n}/${lim} agents actifs.`}{" "}
          <NavLink to={upgrade} className="font-semibold underline" data-testid="agent-limit-upgrade-link">Passer au palier supérieur</NavLink>
        </div>
      )}
    </>
  );
};
